module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/thurston_promo.eec7dde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/thurston_promo.jpg
// module id = 5fHO
// module chunks = 1